import theme from "./theme";
import variant from "./variant";
import colors from "../theme/colors";
export const color = variant("mode", "color", colors);
export const textColor = theme("mode", colors.text);
export const clipColor = theme("mode", colors.clip);
export const warningColor = theme("mode", colors.warning);
export const dividerColor = theme("mode", colors.divider);
export const defaultColor = theme("mode", colors.default);
export const primaryColor = theme("mode", colors.primary);
export const selectedColor = theme("mode", colors.selected);
export const positiveColor = theme("mode", colors.positive);
export const negativeColor = theme("mode", colors.negative);
export const secondaryColor = theme("mode", colors.secondary);
export default color;
//# sourceMappingURL=color.js.map